<app-card [isHeader]=true [title]="'search_filter'|translate">


    <form (ngSubmit)="submit()" [formGroup]="form">

        <div>
            <div class="row">
                <div class="col-md-4 col-sm-12">
                    <app-select-common
                            (object)="send($event)"
                            [code]="'CR00'"
                            [control]="getFormControl('categorie')"
                            [label]="'Type du demandeur'"
                            [withcommonid]="true"
                            [withfiltre]="true"
                            [withlibelle]="true"
                            (deleteAllObject)="deleteAllObject()"
                    ></app-select-common>
                </div>

                <div class="col-md-4 col-sm-12">
                    <app-select-common (object)="sendfils2($event)"
                                       *ngIf="getFormControl('categorie').value!=null"
                                       [code]="code"
                                       [control]="getFormControl('souscategorie')"
                                       [label]="'Classification'"
                                       [withcommonid]="true"
                                       [withfiltre]="true"
                                       [withlibelle]="true"

                    ></app-select-common>
                </div>
                <div class="col-md-4 col-sm-12">
                    <app-select-common *ngIf="getFormControl('souscategorie').value!=null"
                                       [code]="code2"
                                       [control]="getFormControl('class')"
                                       [label]="'Sous Classification'"
                                       [withcommonid]="true"
                                       [withfiltre]="true"
                                       [withlibelle]="true"
                    ></app-select-common>
                </div>

            </div>


            <div class="row">
                <div class="col-md-4 col-sm-12">
                    <app-text-field
                            [control]="getFormControl('title')"
                            [label]="'Objet'"
                    ></app-text-field>
                </div>

                <div class="col-md-4 col-sm-12">

                    <app-text-field
                            [control]="getFormControl('moderNm')"
                            [label]="'faq_redacteur'"
                    ></app-text-field>
                </div>
            </div>


            <div class="row">

                <div class="col-md-4 col-sm-12">
                    <button class="btn-blue" mat-flat-button type="submit">
                        <mat-icon>{{ icons.search }}</mat-icon>
                        <span translate>search</span>
                    </button>

                    <button (click)="reset()"
                            color="primary"
                            mat-flat-button
                            style="margin:5px;"
                            type="button"
                    >
                        <mat-icon>{{ icons.reset }}</mat-icon>
                        <span translate>reset</span>
                    </button>
                </div>
            </div>


        </div>


    </form>
</app-card>
